import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../styles/admin.css';

const AdminLogin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/login`, { username, password });
      localStorage.setItem('token', res.data.token);
      navigate('/admin'); // Redirect to admin dashboard
    } catch (err) {
      alert('Login failed');
    }
  };

  return (
    <div className="admin-layout">
      <div className="admin-login-card">
        <div className="text-center mb-4">
          <div className="admin-login-brand">Blue Nest Hotel</div>
          <p className="admin-login-subtitle mb-0">Admin Portal</p>
        </div>

        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label className="form-label small text-muted">Username</label>
            <input
              className="form-control admin-input"
              placeholder="Enter username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="mb-4">
            <label className="form-label small text-muted">Password</label>
            <input
              className="form-control admin-input"
              placeholder="Enter password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="btn btn-primary w-100 admin-login-button mb-3">
            Login
          </button>

          <div className="text-center admin-login-footer mt-2">
            Blue Nest Hotel &copy; {new Date().getFullYear()}
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
